<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item " v-bind:key="index" v-for="(button, index) in buttons"
              :class="activeButton === button.value ? 'active ' : ''">
            <a href="javascript:;" @click="selectButton(button.value)" class="nav-link">
              {{ button.label }}
              <slot v-if="button.id" :name="'slot-' + button.id"></slot>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
/**
 * @INPUT: buttons: array of objects containing { value, label } => Value = returning value on click, label = displaying value
 * @INPUT: defaultSelectedIndex: index of the default selected button. (optional)
 * @OUTPUT: tabClicked: emits $event => $event = the value of the clicked button
 */
export default {
  name: "TabBar",
  props: ['buttons', 'defaultSelectedIndex'],
  data() {
    return {
      activeButton: null
    }
  },
  methods: {
    selectButton(value) {
      this.activeButton = value;
      this.$emit('tabClicked', value);
    },
    selectDefaultButton() {
      if (this.defaultSelectedIndex !== null && this.defaultSelectedIndex !== undefined) {
        this.selectButton(this.buttons[this.defaultSelectedIndex].value);
      }
    }
  },
  created() {
    this.selectDefaultButton();
  },
  watch: {
    buttons: {
      deep: true,
      handler() {
        this.selectDefaultButton();
      }
    },
    defaultSelectedIndex: {
      deep: false,
      handler() {
        this.selectDefaultButton();
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-left:0px
}
.nav-item.active {
  -webkit-transition: border-bottom-color linear 300ms;
  transition: border-bottom-color linear 300ms;
  border-bottom: 3px solid #00c9ff;
}
</style>